export function isOverlayAutoplaying(model) {
    return model.sections.some((section) => section.sectionKind === 'actions'
        && section.actions.some((action) => action.playbackRole === 'toggle' && action.isActive));
}
export function withOverlayPlaybackControls(model, active, paused) {
    const playing = isOverlayAutoplaying(model);
    const locked = active || paused || playing;
    if (!locked)
        return model;
    return {
        ...model,
        sections: model.sections.map((section) => {
            if (section.sectionKind === 'select' || section.sectionKind === 'checkbox') {
                return section.allowDuringPlayback ? section : { ...section, enabled: false };
            }
            if (section.sectionKind === 'text-input')
                return { ...section, enabled: false };
            if (section.sectionKind !== 'actions')
                return section;
            const hasPlayback = section.actions.some((action) => action.playbackRole === 'toggle');
            return {
                ...section,
                ...(hasPlayback ? { description: paused ? 'Paused' : 'Playing' } : {}),
                actions: section.actions.map((action) => {
                    if (action.playbackRole === 'toggle') {
                        return { ...action, label: paused ? 'Play' : 'Pause', enabled: true, isActive: !paused };
                    }
                    if (action.playbackRole === 'reset')
                        return { ...action, enabled: true };
                    if (action.allowDuringPlayback)
                        return action;
                    return { ...action, enabled: false };
                }),
            };
        }),
    };
}
export function isOverlayIntentEnabled(model, intent) {
    if (intent.overlayIntentKind === 'action-triggered') {
        return model.sections.some((section) => section.sectionKind === 'actions'
            && section.actions.some((action) => action.actionId === intent.actionId && (action.enabled ?? true)));
    }
    return model.sections.some((section) => section.sectionId === intent.sectionId
        && ((intent.overlayIntentKind === 'select-changed' && section.sectionKind === 'select')
            || (intent.overlayIntentKind === 'checkbox-changed' && section.sectionKind === 'checkbox')
            || (intent.overlayIntentKind === 'text-changed' && section.sectionKind === 'text-input'))
        && (section.enabled ?? true));
}
